var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as Apollo from "@apollo/client";
import * as Remote from "@vividtheory/remotedata";
import React from "react";
export function remoteUseQueryResponse(queryReturn) {
    return (remote, setRemote) => ({
        remote,
        setRemote,
        queryReturn,
    });
}
export function remoteUseLazyQueryResponse(queryReturn) {
    const executeRemoteQuery = (options) => __awaiter(this, void 0, void 0, function* () {
        const executeQuery = queryReturn[0];
        const result = yield executeQuery(options);
        if (result.data) {
            return new Remote.Success(result.data);
        }
        return new Remote.Failure("Error");
    });
    return (remote) => ({
        remote,
        queryReturn,
        executeQuery: queryReturn[0],
        executeRemoteQuery,
    });
}
export function useRemoteLazyQuery(query, options = {}) {
    const queryReturn = Apollo.useLazyQuery(query, options);
    const respone = remoteUseLazyQueryResponse(queryReturn);
    const ret = queryReturn[1];
    if (ret.data) {
        return respone(new Remote.Success(ret.data));
    }
    if (ret.error) {
        return respone(new Remote.Failure(ret.error));
    }
    if (ret.loading) {
        return respone(new Remote.Pending());
    }
    return respone(new Remote.Initialized());
}
export function useRemoteQuery(query, options = {}) {
    const [remote, setRemote] = React.useState(new Remote.Initialized());
    const queryReturn = Apollo.useQuery(query, Object.assign(Object.assign({ errorPolicy: "all" }, options), { onCompleted: (d) => {
            var _a;
            setRemote(new Remote.Success(d));
            (_a = options.onCompleted) === null || _a === void 0 ? void 0 : _a.call(options, d);
        }, onError: (e) => {
            var _a;
            setRemote(new Remote.Failure(e));
            (_a = options.onError) === null || _a === void 0 ? void 0 : _a.call(options, e);
        } }));
    const respone = remoteUseQueryResponse(queryReturn);
    if (queryReturn.loading) {
        return respone(new Remote.Pending(), setRemote);
    }
    return respone(remote, setRemote);
}
export function remoteUseMutationResponse(mutationReturn) {
    const executeRemoteMutation = (options) => __awaiter(this, void 0, void 0, function* () {
        const executeMutation = mutationReturn[0];
        const result = yield executeMutation(options);
        if (result.data) {
            return new Remote.Success(result.data);
        }
        return new Remote.Failure("Error");
    });
    return (remote) => ({
        remote,
        mutationReturn,
        executeMutation: mutationReturn[0],
        executeRemoteMutation,
    });
}
export function useRemoteMutation(mutation, options = {}) {
    const mutationReturn = Apollo.useMutation(mutation, options);
    const ret = mutationReturn[1];
    const respone = remoteUseMutationResponse(mutationReturn);
    if (ret.data) {
        return respone(new Remote.Success(ret.data));
    }
    if (ret.error) {
        return respone(new Remote.Failure(ret.error));
    }
    if (ret.loading) {
        return respone(new Remote.Pending());
    }
    return respone(new Remote.Initialized());
}
export function remoteUseSubscriptionResponse(queryReturn) {
    return (remote) => ({
        remote,
        queryReturn,
    });
}
export function useRemoteSubscription(query, options = {}) {
    const subReturn = Apollo.useSubscription(query, options);
    const respone = remoteUseSubscriptionResponse(subReturn);
    if (subReturn.data) {
        return respone(new Remote.Success(subReturn.data));
    }
    if (subReturn.error) {
        return respone(new Remote.Failure(subReturn.error));
    }
    if (subReturn.loading) {
        return respone(new Remote.Pending());
    }
    return respone(new Remote.Initialized());
}
//# sourceMappingURL=index.js.map